import styled from 'styled-components';

export const ProjectContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 15px;
  align-items: center;
  min-height: calc(100vh - 130px);

  .header {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .consolidate-btn {
      svg {
        path {
          fill: transparent !important;
        }
      }
    }

    .meta {
      display: flex;
      gap: 8px;

      div:not(:last-child) {
        border-right: 1px solid #cdd4df;
        padding-right: 6px;
      }
    }

    .actions {
      display: flex;
      align-items: center;
      gap: 8px;

      button {
        background-color: #228be6;
        border-color: #228be6;

        svg {
          width: 16px;
          height: 16px;

          path {
            stroke: white;
          }
        }
      }

      label {
        span {
          width: 100px;
          height: 27px;
          border-radius: 7px;
          background: #3d3bff33;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          font-size: 12px;
          font-weight: 500;
          line-height: 19.41px;
          text-align: center;
        }

        input {
          display: none;
        }
      }
    }
  }

  .count {
    min-width: 16px;
    height: 16px;
    border-radius: 16px;
    background: #1971c2;
    color: #fff;
    font-size: 12px;
    font-weight: 600;
    line-height: 17px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .files {
    width: 100%;
    padding: 0 12px 12px;
    gap: 8px;
    display: flex;
    flex-direction: column;
  }

  .main {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 12px;

    .info {
      display: flex;
      width: 50%;
      gap: 12px;
      background: #edf0f5;
      padding: 16px;
      border-radius: 12px;

      .project {
        border-right: 1px solid #cdd4df;
        padding-right: 12px;
      }

      label {
        font-size: 16px;
        font-weight: 600;
        line-height: 24px;
        text-align: left;
      }

      .input-wrapper {
        min-width: 300px;
        padding: 12px;
        background-color: #fff;

        input {
          background-color: #fff;
        }
      }
    }
  }

  .box {
    background: #fff;
    width: ${({ width }) => width || '100%'};
    border-radius: 4px;
    border: 1px solid #f1f3f5;
    flex: 1;
    max-height: calc(100vh - 170px);
    overflow-y: auto;

    .table_actions {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      gap: 10px;
    }

    .empty {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      h2 {
        margin-top: 16px;
        font-size: 24px;
        font-weight: 600;
        line-height: 24px;
        letter-spacing: 0em;
        text-align: left;
        color: #2b313d;
      }

      p {
        margin-top: 12px;
        font-size: 16px;
        font-weight: 500;
        line-height: 19px;
        letter-spacing: 0em;
        text-align: left;
        color: #9f9f9f;
      }

      button {
        margin-top: 32px;
      }
    }
  }
`;

export const CreateProjectModalContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 617px;
  height: 324px;
  padding: 56px;
  background: #edf0f5;
  border-radius: 12px;
  margin-top: 10px;
  flex-direction: column;

  form {
    width: 100%;
  }

  .box {
    background-color: #fff;
  }

  .actions {
    width: 100%;
    margin-top: 24px;
    display: flex;
    justify-content: flex-end;
  }
`;

export const CreatePeriodModalContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 842px;
  height: 485px;
  padding: 56px;
  background: #fff;
  border-radius: 12px;
  margin-top: 10px;
  flex-direction: column;

  .box {
    width: 100%;
    padding: 16px;
    border-radius: 16px;
    background-color: #edf0f5;
  }

  .divider {
    border-bottom: 1px solid #cdd4df;
    width: 100%;
    height: 1px;
    margin: 24px 0;
  }

  .actions {
    width: 100%;
    display: flex;
    justify-content: center;
    gap: 16px;
  }
`;
